import { useTranslation } from 'react-i18next';
import { Accordion } from '@/components/molecules/Accordion';
import type { AccordionItemData } from '@/components/molecules/Accordion';
import { ROUTES } from '@/constants/routes';
import styles from './SupportPage.module.scss';

const SUPPORT_EMAIL = 'support@knooowy.com';

interface Faq {
  q: string;
  a: string;
}

export function SupportPage() {
  const { t } = useTranslation();

  const faqs = t('supportPage.faqs', { returnObjects: true });
  const faqItems: AccordionItemData[] = (Array.isArray(faqs) ? (faqs as Faq[]) : []).map(
    (faq, i) => ({ id: `faq-${i}`, title: faq.q, content: faq.a })
  );

  return (
    <div className={styles.support}>
      <header className={styles.support__intro}>
        <h1 className={styles.support__title}>{t('supportPage.title')}</h1>
        <p className={styles.support__subtitle}>{t('supportPage.subtitle')}</p>
      </header>

      <section className={styles.support__section} aria-labelledby="support-faq">
        <h2 id="support-faq" className={styles.support__sectionTitle}>
          {t('supportPage.faqTitle')}
        </h2>
        <Accordion items={faqItems} />
      </section>

      <section className={styles.support__section} aria-labelledby="support-contact">
        <h2 id="support-contact" className={styles.support__sectionTitle}>
          {t('supportPage.contactTitle')}
        </h2>
        <p className={styles.support__text}>
          {t('supportPage.contactIntro')}{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className={styles.support__link}>
            {SUPPORT_EMAIL}
          </a>
        </p>
      </section>

      <section className={styles.support__section} aria-labelledby="support-legal">
        <h2 id="support-legal" className={styles.support__sectionTitle}>
          {t('supportPage.legalTitle')}
        </h2>
        <p className={styles.support__text}>{t('supportPage.legalIntro')}</p>
        <ul className={styles.support__legalLinks}>
          <li>
            <a href={ROUTES.LEGAL.PRIVACY} target="_blank" rel="noopener noreferrer">
              {t('supportPage.legalPrivacy')}
            </a>
          </li>
          <li>
            <a href={ROUTES.LEGAL.TERMS} target="_blank" rel="noopener noreferrer">
              {t('supportPage.legalTerms')}
            </a>
          </li>
          <li>
            <a href={ROUTES.LEGAL.COOKIES} target="_blank" rel="noopener noreferrer">
              {t('supportPage.legalCookies')}
            </a>
          </li>
        </ul>
      </section>
    </div>
  );
}

export default SupportPage;
